(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-essential"]) return;
  try {
    
if(!customElements.get('arrondi-essential')){
  customElements.define('arrondi-essential',class extends HTMLElement{
    connectedCallback(){
      const select=this.querySelector('[data-essential-variant]');
      if(!select)return;
      select.addEventListener('change',()=>{
        const option=select.selectedOptions[0];
        const available=option.dataset.available==='true';
        this.querySelector('[data-essential-price]').textContent=option.dataset.price;
        const button=this.querySelector('[data-essential-add]');
        button.disabled=!available;
        button.textContent=available?'Add to bag':'Sold out';
        const url=new URL(window.location.href);url.searchParams.set('variant',select.value);window.history.replaceState({},'',url);
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
